import React, { useEffect, useState } from 'react';
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
function getTimeLeft(targetTime: number): TimeLeft {
  const diff = Math.max(0, targetTime - Date.now());
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(diff % (1000 * 60) / 1000);
  return {
    hours,
    minutes,
    seconds
  };
}
function pad(n: number): string {
  return String(n).padStart(2, '0');
}
interface CountdownTimerProps {
  size?: 'sm' | 'md' | 'lg';
  blinking?: boolean;
}
export function CountdownTimer({
  size = 'md',
  blinking = false
}: CountdownTimerProps) {
  const [targetTime] = useState(() => Date.now() + 24 * 60 * 60 * 1000);
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(getTimeLeft(targetTime));
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeLeft(targetTime));
    }, 1000);
    return () => clearInterval(interval);
  }, [targetTime]);
  const sizeClasses = {
    sm: {
      digit: 'text-sm font-bold',
      label: 'text-[9px]',
      separator: 'text-sm font-bold',
      wrapper: 'gap-0.5'
    },
    md: {
      digit: 'text-4xl font-black',
      label: 'text-xs',
      separator: 'text-4xl font-black',
      wrapper: 'gap-2'
    },
    lg: {
      digit: 'text-6xl md:text-7xl font-black',
      label: 'text-sm',
      separator: 'text-6xl md:text-7xl font-black',
      wrapper: 'gap-3'
    }
  };
  const classes = sizeClasses[size];
  const colorClass = blinking ? 'countdown-blink' : 'text-red-urgency';
  return <div className={`flex items-center justify-center ${classes.wrapper} gap-[0px]`} data-id="element-60">
      <div className="flex flex-col items-center" data-id="element-61">
        <span className={`${classes.digit} ${colorClass} font-black tabular-nums text-[#FFFFFF]`} data-id="element-62">
          {pad(timeLeft.hours)}
        </span>
        <span className={`${classes.label} text-gray-300 uppercase tracking-wider`} data-id="element-63">
          hs
        </span>
      </div>
      <span className={`${classes.separator} ${colorClass} mb-4`} data-id="element-64">:</span>
      <div className="flex flex-col items-center" data-id="element-65">
        <span className={`${classes.digit} ${colorClass} font-black tabular-nums text-[#FFFFFF]`} data-id="element-66">
          {pad(timeLeft.minutes)}
        </span>
        <span className={`${classes.label} text-gray-300 uppercase tracking-wider`} data-id="element-67">
          min
        </span>
      </div>
      <span className={`${classes.separator} ${colorClass} mb-4`} data-id="element-68">:</span>
      <div className="flex flex-col items-center" data-id="element-69">
        <span className={`${classes.digit} ${colorClass} font-black tabular-nums text-[#FFFFFF]`} data-id="element-70">
          {pad(timeLeft.seconds)}
        </span>
        <span className={`${classes.label} text-gray-300 uppercase tracking-wider`} data-id="element-71">
          seg
        </span>
      </div>
    </div>;
}